import * as React from "react";

function SvgFactorsAi(props, ref) {
  return (
    <svg
      id="FactorsAI_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 39.4 34"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {
          ".FactorsAI_svg__st0,.FactorsAI_svg__st1,.FactorsAI_svg__st2{fill-rule:evenodd;clip-rule:evenodd}.FactorsAI_svg__st0{display:none;fill:#2c3031}.FactorsAI_svg__st1,.FactorsAI_svg__st2{fill:#035dd2}.FactorsAI_svg__st1{display:none}.FactorsAI_svg__st2{stroke:#035dd2}"
        }
      </style>
      <g id="FactorsAI_svg__Page-1">
        <g id="FactorsAI_svg__Logo" transform="translate(-182 -740)">
          <g id="FactorsAI_svg__logo_with_name" transform="translate(183 741)">
            <path
              id="FactorsAI_svg__Fill-73"
              className="FactorsAI_svg__st0"
              d="M48.2 3.4c.9 0 1.4.1 2.4.2v2.8c-.4 0-.9-.1-1.3-.1-1.4 0-1.6 1-1.6 2.3V10h2.9v2.8h-2.9v15.9h-3.8V12.8H42V10h1.9v-.7c0-3.7.6-5.9 4.3-5.9"
            />
            <path
              id="FactorsAI_svg__Fill-74"
              className="FactorsAI_svg__st0"
              d="M57 23.6c0 1.4.5 2.3 1.9 2.3.9 0 1.5-.8 1.9-1.4v-5.2c-1.4 1.1-3.8 2-3.8 4.3zm7.7-8V24c0 1.9.1 3.4.5 4.7h-3.8l-.5-2.8c-.8 1.5-1.7 3.1-3.9 3.1s-3.8-2.2-3.8-4.4c0-4.9 4-6.2 7.6-7.6v-1.3c0-1.7-.3-3-1.9-3-1.6 0-1.9 1.3-1.9 3h-3.8c0-3.5 2.1-5.9 5.7-5.9 3.7-.1 5.8 2.3 5.8 5.8z"
            />
            <path
              id="FactorsAI_svg__Fill-75"
              className="FactorsAI_svg__st0"
              d="M75.1 25.9c1.9 0 1.9-1.9 1.9-3.7h3.8c0 4.1-1.5 6.8-5.7 6.8-5.2 0-5.7-4.6-5.7-9.6 0-5.1.6-9.6 5.7-9.6 4.4 0 5.7 2.6 5.7 6.8H77c0-1.8-.1-3.9-1.9-3.9-2.3 0-1.9 4.3-1.9 6.7 0 2.3-.4 6.5 1.9 6.5"
            />
            <path
              id="FactorsAI_svg__Fill-76"
              className="FactorsAI_svg__st0"
              d="M90.1 29c-3.1 0-4.3-1.6-4.3-4.5V12.8h-1.9V10h1.9V3.4h3.8V10h2.9v2.8h-2.9v10.9c0 1.3.2 2.2 1.6 2.2.4 0 .9-.1 1.3-.1v3c-1 .1-1.5.2-2.4.2"
            />
            <path
              id="FactorsAI_svg__Fill-77"
              className="FactorsAI_svg__st0"
              d="M100.1 16.5v5.6c0 1.9 0 3.7 1.9 3.7s1.9-1.9 1.9-3.7v-5.6c0-1.9 0-3.7-1.9-3.7s-1.9 1.9-1.9 3.7zm-3.8 5.7v-5.6c0-4.2 1.4-6.8 5.7-6.8 4.3 0 5.7 2.7 5.7 6.8v5.6c0 4.2-1.4 6.8-5.7 6.8-4.3 0-5.7-2.7-5.7-6.8z"
            />
            <path
              id="FactorsAI_svg__Fill-78"
              className="FactorsAI_svg__st0"
              d="M120.7 9.7c.2 0 .3 0 .6.1v4.1c-.6-.2-1.4-.4-2.1-.4-1.6 0-2.7 1-2.7 2.6v12.6h-3.8V10h3.8v2.5c.7-1.3 2.3-2.8 4.2-2.8"
            />
            <path
              id="FactorsAI_svg__Fill-79"
              className="FactorsAI_svg__st0"
              d="M129.5 12.8c-1.2 0-1.9.7-1.9 1.9 0 .7.5 1.3 1 1.6l3.8 2.8c1.5 1.2 2.9 2.6 2.9 5 0 3.3-2.3 4.9-5.7 4.9-3.4 0-5.1-2.3-5.7-4.9l2.9-.9c.4 1.2 1.3 2.8 2.9 2.8 1.2 0 1.9-.7 1.9-1.9 0-1-.4-1.7-1-2.2l-3.8-2.8c-1.4-1-2.9-2.2-2.9-4.4 0-3.3 2.3-4.9 5.7-4.9 3.4 0 5.1 2.3 5.7 4.9l-2.9.9c-.5-1.2-1.2-2.8-2.9-2.8"
            />
            <path
              id="FactorsAI_svg__Fill-80"
              className="FactorsAI_svg__st1"
              d="M138.8 28.7h3.8V25h-3.8z"
            />
            <path
              id="FactorsAI_svg__Fill-81"
              className="FactorsAI_svg__st1"
              d="M150 23.6c0 1.4.5 2.3 1.9 2.3.9 0 1.5-.8 1.9-1.4v-5.2c-1.5 1.1-3.8 2-3.8 4.3zm7.7-8V24c0 1.9.1 3.4.5 4.7h-3.8l-.5-2.8c-.8 1.5-1.6 3.1-3.8 3.1-2.2 0-3.8-2.2-3.8-4.4 0-4.9 4-6.2 7.6-7.6v-1.3c0-1.7-.3-3-1.9-3-1.6 0-1.9 1.3-1.9 3h-3.8c0-3.5 2.1-5.9 5.7-5.9 3.6-.1 5.7 2.3 5.7 5.8z"
            />
            <path
              id="FactorsAI_svg__Fill-82"
              className="FactorsAI_svg__st1"
              d="M162.9 28.7h3.8V10h-3.8v18.7zm0-21.5h3.8V3.4h-3.8v3.8z"
            />
            <path
              id="FactorsAI_svg__Fill-83"
              className="FactorsAI_svg__st2"
              d="M9.9 27.8h-.2L4.1 18c.4-.4.6-1 .6-1.6s-.2-1.2-.6-1.6L9.9 4.7c1.3 0 2.3-1 2.3-2.3 0-1.3-1-2.3-2.3-2.3S7.6 1 7.6 2.3c0 .6.2 1.1.6 1.5L2.3 14.1c-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3l5.8 10c-.3.4-.5.9-.5 1.4 0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3-1-2.3-2.3-2.3"
            />
            <path
              id="FactorsAI_svg__Fill-84"
              className="FactorsAI_svg__st2"
              d="M36.6 16.4c0-1.3-1-2.3-2.3-2.3L28.4 3.9c.4-.4.6-1 .6-1.5C29 1 27.9 0 26.6 0s-2.3 1-2.3 2.3c0 1.3 1 2.3 2.3 2.3l5.9 10.2c-.4.4-.6.9-.6 1.5s.2 1.1.6 1.5l-5.7 9.8h-.2c-1.3 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3c0-.5-.2-1-.5-1.4l5.8-10c1.3.2 2.4-.8 2.4-2.1"
            />
            <path
              id="FactorsAI_svg__Fill-85"
              className="FactorsAI_svg__st2"
              d="M23.5 7.7c-.4-.2-.9-.1-1.1.3L13 23.4c-.2.4-.1.9.3 1.1.4.2.9.1 1.1-.3l9.3-15.4c.3-.4.2-.9-.2-1.1"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgFactorsAi);
